<template>
    <div>
        <transition name="component-fade" mode="out-in">
        <div class="products-list" v-if="isLoad">
            <div v-for="product of products" class="white_container shop_wrap" :class="[product.ribbon.title !== null?'highlight':null]">
                <div class="highlight_wrap" v-if="product.ribbon.title !== null">
                    <div class="icon-thumbs-up"></div>
                    <p>{{product.ribbon.title}}</p>
                </div>
                <div class="text_wrap">
                    <h2>{{product.qty}}</h2>
                    <h4>Lecții</h4>
                    <div class="product-title">{{product.title}}</div>
                    <p class="old_price" :style="{opacity: product.price.sale !== null?1:0}">{{formatPrice(round2(product.price.regular))}}</p>
                    <p class="price" v-if="product.price.sale !== null">{{formatPrice(round2(product.price.sale))}}</p>
                    <p class="price" v-if="product.price.sale === null">{{formatPrice(round2(product.price.regular))}}</p>
                    <p class="discount_value">{{formatPrice(round2(product.price.unit),product.currency)}}/{{$t("shop.LBL_LECTIE_PRICE")}}</p>
                    <p class="discount_value" :style="{opacity: product.price.sale !== null?1:0}">{{$t("shop.LBL_DISCOUNT_VALUE")}} {{product.price.discount}}%</p>
                    <button v-on:click="startPaymentFlow(product)" class="button" v-html="$t('shop.BTN_MAKE_ORDER')"></button>
                </div>
            </div>
        </div>
        </transition>
        <PayMethodPopup
            :show="showPayMethodPopup"
            :selectedProduct="selectedProduct"
            v-on:paymentEvent="paymentFlowRedirectRequest"
            v-on:closeEvent="showPayMethodPopup = !showPayMethodPopup">
        </PayMethodPopup>
        <PaySuccessPopup
            :show="showPaySuccessPopup"
            v-on:closeEvent="showPaySuccessPopup = !showPaySuccessPopup">
        </PaySuccessPopup>
        <PayErrorPopup
            :show="showPayErrorPopup"
            v-on:closeEvent="showPayErrorPopup = !showPayErrorPopup">
        </PayErrorPopup>
    </div>
</template>

<style lang="scss">
.product-title{
    
}
</style>

<script>
    import i18n from '@/i18n';
    import { mapGetters, mapActions } from 'vuex';
    import store from '@/store';
    import PayMethodPopup from './popups/PayMethodPopup';
    import PaySuccessPopup from './popups/PaySuccessPopup';
    import PayErrorPopup from './popups/PayErrorPopup';
    import {decodeHtml} from '@/utils/utils';
    import {formatPrice} from '@/utils/utils';
    import {rest} from '@/utils/utils';

    export default {
        name: 'SpecialOffer',
        components: {
            PayMethodPopup,
            PaySuccessPopup,
            PayErrorPopup
        },
        data: function () {
            return {
                isLoad: false,
                showPayMethodPopup: false,
                showPaySuccessPopup: false,
                showPayErrorPopup: false,
                selectedProduct: null,
                products: [],
            }
        },
        computed:{
            ...mapGetters({
                user: 'user/get',
            }),
        },
        created(){
            this.getProducts();
        },
        mounted(){},
        methods: {
            getProducts(){
                store.commit('loading/is', true);
                this.isLoad = false;
                //Получим товары из предложения
                rest.call("shop_items",{
                    "category_slug":"special",
                    "currency":this.user.currency
                },"GET").then((response)=>{
                    this.isLoad = true;
                    store.commit('loading/is', false);
                    if(response.status && response.status == "ok" && response.products){
                        this.products = response.products;
                    }
                }).catch((error)=>{
                    this.isLoad = true;
                    store.commit('loading/is', false);
                });
            },
            round2(num) {
                return Math.round(num * 100) / 100;
            },
            startPaymentFlow(product) {
                this.selectedProduct = product;
                this.showPayMethodPopup = true;
            },
            formatPrice(value,currency=null){
                currency = currency?currency:this.user.currency;
                return formatPrice(value,currency);
            },
            /**
             * Заказ товара
             */
            paymentFlowRedirectRequest(paymentInfo) {
                store.commit('loading/is', true);
                rest.call("proccess_offer",{
                    "product":paymentInfo.id,
                    "method":paymentInfo.payment_method,
                    "currency":this.user.currency,
                    "rate":paymentInfo.rateEURtoLEI,
                    "qty":paymentInfo.qty,
                    "offer":paymentInfo.offer,
                    "offer_product_id":paymentInfo.offer_product_id,
                },"GET").then((response)=>{
                    store.commit('loading/is', false);
                    if(response.status && response.redirect){
                        window.location.href = decodeHtml(response.redirect);
                    }
                }).catch((error)=>{
                    store.commit('loading/is', false);
                });
            }
        },
        watch:{},
    }
</script>